import {
  GET_SPECIAL_INFO_SUCCESS,
  SET_APP_DETAILS,
  GET_SPECIAL_TAGS_SUCCESS,
  GET_SPECIAL_LIST_SUCCESS,
  GET_SPECIALLIST_BY_SOURCE_SUCCESS,
  GET_SPECIAL_LIST_LOADING,
} from '../constants/special';

const initState = {
  specialInfo: {},
  appDetails: {},
  specialTags: [],
  specialList: [],
  pagenation: {
    code: null,
    limit: 18,
    pageType: 'specialList',
    loading: false,
  },
  recommendSpecialList: [],
};

const special = (state = initState, action = {}) => {
  let list = [];
  switch (action.type) {
    case GET_SPECIAL_INFO_SUCCESS:
      return { ...state, specialInfo: action.payload };
    case SET_APP_DETAILS:
      return { ...state, appDetails: action.payload };
    case GET_SPECIAL_TAGS_SUCCESS:
      return {
        ...state,
        specialTags: action.payload,
      };
    case GET_SPECIAL_LIST_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      list =
        action.payload.pagenation.refresh ||
        action.payload.pagenation.code !== state.pagenation.code
          ? action.payload.specialList
          : [...state.specialList, ...action.payload.specialList];
      return {
        ...state,
        pagenation: {
          ...state.pagenation,
          ...action.payload.pagenation,
        },
        specialList: list,
      };
    case GET_SPECIAL_LIST_LOADING:
      return {
        ...state,
        pagenation: {
          ...state.pagenation,
          ...action.payload.pagenation,
        },
      };
    case GET_SPECIALLIST_BY_SOURCE_SUCCESS:
      return {
        ...state,
        recommendSpecialList: action.payload,
      };
    default:
      return state;
  }
};

export default special;
